<div class="row no-gutters">
  <div class="col-3 col-lg-2" *ngFor="let card of gameData; let i = index">
    <div class="card" (click)="flip($event, card.value, i)" [id]="i" [ngClass]="{'is-flipped': card.flipped}">
      <div class="card__face card__face--front"></div>
      <div class="card__face card__face--back"
            [ngStyle]="{ 'background-image': 'url(' + card.imagePath + ')'}"></div>
    </div>
  </div>
</div>
